import Vue from 'vue';

const barramento = new Vue();

export default {
    barramento: barramento,
    ABRIR_DIALOG_COMANDA: 'Abrir tela de edição de comandas',
    ATUALIZAR_TELA: 'Atualizar todos os dados da tela',
    BLOQUEIOS_ATUALIZADOS: 'Bloqueios de horário alterados',
    COMANDA_ALTERADA: 'Comanda alterada',
    LEMBRETE_CRIADO: 'Lembrete criado',
    UPPY_CRIADO: 'Instância do Uppy criada',
    GRAVAR_FORMULARIO_FB: 'Gravar formulário editado no FormBuilder',
    ABRIR_DIALOG_ORCAMENTO: 'Abrir edição de orçamentos',
    ABRIR_DIALOG_SIGNATARIOS: 'Abrir edição de signatários',
    ABRIR_DIALOG_ASSINATURA_PRESENCIAL: 'Abrir tela para assinatura presencial',
    ORCAMENTO_SALVO: 'Orcamento Salvo',
    ORCAMENTO_ID_TO_SHOW_DETAILS: 'Abrir detalhes de orçamentos'
}
